import { AccessRightKey } from "../Types";

export const DEFAULT_PAGE_LOADING_MESSAGE = "Page en cours de chargement...";

export const DEFAULT_TOAST_DURATION = 5000; // 5s
export const LONG_PROCESS_TOAST_DURATION = 20000; // 20s
export const DEFAULT_SUCCESS_TOAST_DURATION = 1500; //1.5s;

export const DEFAULT_ANIMATION_DURATION = 500; // 0.5s

export const DEFAULT_MODAL_ANIMATION_DURATION = 500; // 0.5s

export const REACT_SELECT_SEARCHABLE_THRESHOLD = 10;

export const notificationSound = new Audio('/medias/new-badge.mp3');


export const ACCESS_RIGHT_KEYS: AccessRightKey[] = [
    'read', 
    'write', 
    'delete', 
    'restore', 
    'export', 
    'execute', 
    'audit'
];

export const SALE_OPERATION_TYPE = 'sale';

export const OTHER_TYPE = 'other';

export const SEARCH_PROPERTY_RENT_MANADTE_TYPE = 'search_property_rent_mandate';

export const SALE_MANDATE_TYPE = 'sale_mandate';

export const RENT_MNGT_MANDATE_TYPE = 'rent_management_mandate';